import { Link } from 'react-router-dom';
import useFetch from '../hooks/useFetch';
import { getGalleryItems } from '../services/api';

const Gallery = () => {
  const { data: galleryItems, loading, error } = useFetch(getGalleryItems);

  return (
    <section className="gallery" id="gallery" aria-label="Recent projects">
      <div className="container">
        <div className="section-header">
          <p className="section-eyebrow">Our Work</p>
          <h2 className="section-title">Featured Projects</h2>
          <div className="section-rule" aria-hidden="true"></div>
          <p className="gallery__intro">
            Every project is built to last — browse a selection of our recent
            work across South East London.
          </p>
        </div>

        {loading && <div className="gallery__state">Loading gallery…</div>}
        {error && (
          <div className="gallery__state gallery__state--error">
            Unable to load gallery. Please try again later.
          </div>
        )}

        {galleryItems && (
          <div className="gallery__grid">
            {galleryItems.map((item, idx) => (
              <Link
                to={`/projects/${item.id}`}
                key={item.id}
                className="gallery__item"
                aria-label={`View project: ${item.title}, ${item.location}`}
              >
                <img
                  src={item.image}
                  alt={item.alt}
                  loading={idx < 2 ? 'eager' : 'lazy'}
                />

                <div className="gallery__caption">
                  <div className="gallery__caption-text">
                    <p className="gallery__caption-location">{item.location}</p>
                    <h3 className="gallery__caption-title">{item.title}</h3>
                  </div>
                  <span className="gallery__caption-arrow" aria-hidden="true">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="5" y1="12" x2="19" y2="12" />
                      <polyline points="12 5 19 12 12 19" />
                    </svg>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;
